import {
  Attribution,
  GetSessionV2Response,
} from "@endavaaccorplus/payments-common/schemas";
import { formatInTimeZone } from "date-fns-tz";
import { TransactionStatusId } from "../transaction-status";
import { getComplementaryAttribute } from "./get-complementary-attribute";
import { getSubscriptionType } from "./get-subscription-type-attribute";
import { getPwpPaidAttributes } from "./get-pwp-paid-attribute";
import { getSourceAttribute } from "./get-source-attribute";
import { getChannelTypeAttribution } from "./get-channel-type-attribute";
import { getResidenceAttribute } from "./get-residence-attribute";
import { getSubsidiaryAttribute } from "./get-subsidiary-attribute";
import { getPwpEligibleAttributes } from "./get-pwp-eligible-attribute";
import type { IntegrationSource } from "@/lib/checkout/integration-sources";
import { toGtmIntegrationSource } from "@/lib/tracking/gtm-integration-source";

type GetGtmPurchaseEventPropsProps = {
  session: GetSessionV2Response;
  transactionId: string;
  transactionStatusId: TransactionStatusId;
  attributionData?: Attribution;
  integrationSource?: IntegrationSource;
};

export const getGtmPurchaseEventProps = ({
  session,
  transactionId,
  attributionData,
  integrationSource = "none",
}: GetGtmPurchaseEventPropsProps) => {
  let netsuiteCouponCode = "";

  if (session.type === "register-partner") {
    netsuiteCouponCode =
      session.partner?.fields.find((f) => f.type === "netsuite-couponCode")
        ?.value ?? "";
  }
  return {
    ecommerce: {
      transaction_id: transactionId,
      affiliation: "Accor Plus",
      value: session.purchaseAmount?.price,
      currency: session.purchaseAmount?.currencyCode,
      coupon: netsuiteCouponCode,
      items: [
        {
          item_id: session.product?.itemGroup?.itemGroupId,
          item_name: session.product?.itemGroup?.itemGroupName,
          item_category: session.product?.businessCategory?.businessCategoryId,
          currency: session.purchaseAmount?.currencyCode,
          discount:
            Number(session.purchaseAmount?.fullPrice) -
            Number(session.purchaseAmount?.price),
          index: 0,
          price: session.purchaseAmount?.price,
          location_id: session.product?.businessCategory?.locationId,
          price_no_tax: session.product?.itemGroup?.purchaseBasePrice,
          quantity: 1,
        },
      ],
      payment_type: "juspay",
      campaign_id: session?.product?.businessCategory?.businessCategoryId,
    },
    channel_type: getChannelTypeAttribution(session?.attribution?.origin),
    pwp_paid: getPwpPaidAttributes(session),
    pwp_eligible: getPwpEligibleAttributes(session),
    subscription_type: getSubscriptionType(session),
    source: getSourceAttribute(attributionData?.origin),
    complementary: getComplementaryAttribute(
      session.product.businessCategory.businessCategoryId,
    ),
    country_subsidiary: getSubsidiaryAttribute(session.product.salesRegion),
    country_residence: getResidenceAttribute(session),
    integration_source: toGtmIntegrationSource(integrationSource),
    purchase_type: session.type === "gift-public" ? "gift" : "self",
    ...(session.type === "gift-public" && {
      recipients_count: session.recipients.length,
      delivery_date: session.dispatch.timezone
        ? formatInTimeZone(
            session.dispatch.scheduledSendAt,
            session.dispatch.timezone,
            "yyyy-MM-dd",
          )
        : session.dispatch.scheduledSendAt.slice(0, 10),
      ...(session.dispatch.timezone && {
        delivery_timezone: session.dispatch.timezone,
      }),
    }),
  };
};
